










import Spinner from './Spinner'
import Button from './Button'
import i18n from '../i18n'
export default
  props: ['text', 'pass', 'back', 'spin', 'error']
  data: -> { i18n }
  components: { Spinner, Button }
